import React, { useEffect, useState } from 'react'
import { Form, Modal as BootstrapModal } from 'react-bootstrap'
import { Account } from '../../models/Account'
import { Modal } from '../Modal/Modal'
import { RoomSession } from '../../models/Room'
import './IntegrationExportConfirmationDialog.scss'

interface ConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  account?: Account
  session?: RoomSession | null
}

export const IntegrationExportConfirmationDialog: React.FC<ConfirmationDialogProps> = ({ isOpen, onClose, onConfirm, account, session }) => {
  const [isAcknowledged, setIsAcknowledged] = useState(false)
  useEffect(() => {
    if (isOpen) {
      setIsAcknowledged(false)
    }
  }, [isOpen])

  const isConfirmationEnforced = account?.effectiveConfig?.complianceConfig?.integrationExportConfirmationConfig?.enabled === true
  const isSessionPrivate = session?.isPrivate
  if (!isConfirmationEnforced && !isSessionPrivate) {
    return null
  }
  const message = isConfirmationEnforced ? account?.effectiveConfig?.complianceConfig?.integrationExportConfirmationConfig?.message || '' : ''
  const privateMessage = isSessionPrivate ? (
    isConfirmationEnforced ? (
      <>
        <br />
        <p>
          This meeting is also private, but we can't control how exported insights are handled in external systems. The insights may become visible to others
          outside the original participant list.
        </p>
      </>
    ) : (
      <p>
        This meeting is private, but Zocks can't control how exported insights are handled in external systems. The insights may become visible to others
        outside the original participant list.
      </p>
    )
  ) : (
    ''
  )

  return (
    <Modal
      header={<BootstrapModal.Title>{isConfirmationEnforced ? 'Review before exporting' : 'Export private meeting insights'} </BootstrapModal.Title>}
      body={
        <div>
          <p>{message}</p>
          {privateMessage}
          {isConfirmationEnforced ? (
            <>
              <Form.Check
                type='checkbox'
                id='acknowledgement-checkbox'
                label='I acknowledge my responsibility to review AI-generated content for accuracy'
                checked={isAcknowledged}
                onChange={(e) => setIsAcknowledged(e.target.checked)}
                className='mt-3'
              />
              <div className='mt-3'>
                <p className='text-muted'>This confirmation is required by your account owner.</p>
              </div>
            </>
          ) : null}
        </div>
      }
      className='integration-export-confirmation-dialog'
      show={isOpen}
      onHide={onClose}
      footerPrimaryActionTitle={'Proceed'}
      showFooterActions={true}
      centered
      headerBodySeparator={true}
      footerPrimaryActionDisabled={isConfirmationEnforced && !isAcknowledged}
      onFooterPrimaryAction={onConfirm}
      onFooterSecondaryAction={onClose}
    ></Modal>
  )
}
